module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAyklEQVRIS+1WsQ3CMBD8c+SeDWAERvAmKNWXKJuEynGVbMIMmYARoE6RR44UhJBQ8haKKOzWd37r/+5skHKFEDoiOhFRzcyVhg4N2Ht/MMbcZg4zq/gqsPfeGWOuudjniHIbp45kgXzz7vYCiclQFMV+KU3GcTwCqGccALfEifvW2r4sywfesm4NLxkjIpdYTJJPUBBFpEfTNDWAs4KXCq22F8jaq2ZT/4+p88yyGn+ixrZtd8Mw3Df5ysUiMUuJyAHomPn13KxR9BMSQHpHQymdQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/imgages/jia.png
// module id = /le/
// module chunks = 1